import { FormEvent, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Mail, ShieldCheck } from 'lucide-react'
import { authService } from '@/services/authService'

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const loginType = params.get('type') === 'member' ? 'member' : 'staff'
  const loginPath = loginType === 'member' ? '/login' : '/user-login'

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setError('')
    setIsLoading(true)
    try {
      await authService.forgotPassword(email)
      navigate(`/reset-password?email=${encodeURIComponent(email.trim())}&type=${loginType}`, { state: { otpSent: true } })
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to send OTP. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 px-4 py-10 flex items-center justify-center">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 sm:p-8 shadow-xl border border-gray-100">
        <div className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
          <ShieldCheck className="h-7 w-7" />
        </div>
        <h1 className="text-center text-2xl font-bold text-gray-900">Reset your password</h1>
        <p className="mt-2 text-center text-sm text-gray-600">Enter your registered email. We’ll send a 6-digit OTP valid for 10 minutes.</p>
        <form onSubmit={handleSubmit} className="mt-7 space-y-5">
          {error && <div className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>}
          <div>
            <label htmlFor="email" className="mb-2 block text-sm font-medium text-gray-700">Registered email</label>
            <div className="relative">
              <Mail className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
              <input id="email" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="name@example.com" className="w-full rounded-xl border border-gray-300 py-3 pl-10 pr-3 focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-200" />
            </div>
          </div>
          <button type="submit" disabled={isLoading} className="w-full rounded-xl bg-emerald-600 px-4 py-3 font-semibold text-white hover:bg-emerald-700 disabled:opacity-60">
            {isLoading ? 'Sending OTP…' : 'Send OTP'}
          </button>
        </form>
        <div className="mt-6 text-center text-sm">
          <Link to={loginPath} className="font-medium text-emerald-700 hover:text-emerald-800">← Back to Login</Link>
        </div>
      </div>
    </div>
  )
}

export default ForgotPasswordPage
